import { Dialog, DialogContent, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { GithubPicker } from "react-color";

const CUSTOM_COLORS_KEY = "customColorPickerColors";

export const normalizeHexColor = color => {
  const trimmedColor = String(color || "").trim();
  if (!trimmedColor) return "";
  const normalizedColor = trimmedColor.startsWith("#")
    ? trimmedColor
    : `#${trimmedColor}`;
  return normalizedColor.toLowerCase();
};

export const isValidHexColor = color => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(
  normalizeHexColor(color)
);

export const saveCustomColor = color => {
  const normalizedColor = normalizeHexColor(color);
  if (!isValidHexColor(normalizedColor)) return;

  const savedColors = JSON.parse(
    localStorage.getItem(CUSTOM_COLORS_KEY) || "[]"
  );
  const colors = [
    normalizedColor,
    ...savedColors.filter(savedColor => savedColor !== normalizedColor),
  ].slice(0, 24);

  localStorage.setItem(CUSTOM_COLORS_KEY, JSON.stringify(colors));
};

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  const [selectedColor, setSelectedColor] = useState(currentColor);
  const [customColors, setCustomColors] = useState([]);
  const colors = [
    "#E8F3FF",
    "#E7F8EF",
    "#F0ECFF",
    "#FFF0E6",
    "#FFEAF1",
    "#FFF7D6",
    "#E4F7F5",
    "#F7E9FF",
    "#FFE7E1",
    "#EEF3F7",
    "#B80000",
    "#DB3E00",
    "#FCCB00",
    "#008B02",
    "#006B76",
    "#1273DE",
    "#004DCF",
    "#5300EB",
    "#EB9694",
    "#FAD0C3",
    "#FEF3BD",
    "#C1E1C5",
    "#BEDADC",
    "#C4DEF6",
    "#BED3F3",
    "#D4C4FB",
    "#4D4D4D",
    "#999999",
    "#FFFFFF",
    "#F44E3B",
    "#FE9200",
    "#FCDC00",
    "#DBDF00",
    "#A4DD00",
    "#68CCCA",
    "#73D8FF",
    "#AEA1FF",
    "#FDA1FF",
    "#333333",
    "#808080",
    "#cccccc",
    "#D33115",
    "#E27300",
    "#FCC400",
    "#B0BC00",
    "#68BC00",
    "#16A5A5",
    "#009CE0",
    "#7B64FF",
    "#FA28FF",
    "#666666",
    "#B3B3B3",
    "#9F0500",
    "#C45100",
    "#FB9E00",
    "#808900",
    "#194D33",
    "#0C797D",
    "#0062B1",
    "#653294",
    "#AB149E",
  ];

  useEffect(() => {
    if (open) {
      setSelectedColor(currentColor);
      setCustomColors(
        JSON.parse(localStorage.getItem(CUSTOM_COLORS_KEY) || "[]")
      );
    }
  }, [currentColor, open]);

  const handleChange = (color) => {
    setSelectedColor(color.hex);
    onChange(color.hex);
    saveCustomColor(color.hex);
    handleClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      maxWidth="xs"
      paperFullWidth
    >
      <DialogContent>
        <GithubPicker
          width={"100%"}
          triangle="hide"
          color={selectedColor}
          colors={colors}
          onChange={handleChange}
        />
        {customColors.length > 0 && (
          <>
            <Typography variant="subtitle2" style={{ marginTop: 16, marginBottom: 8 }}>
              Personalizados
            </Typography>
            <GithubPicker
              width={"100%"}
              triangle="hide"
              color={selectedColor}
              colors={customColors}
              onChange={handleChange}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ColorPicker;

